function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./supply-rows'),
  splitSupplyTableRows = _require.splitSupplyTableRows;
var _require2 = require('./supply-deltas'),
  NET_FLOW_SECTION_TITLE = _require2.NET_FLOW_SECTION_TITLE,
  NET_FLOW_SECTION_ROWS = _require2.NET_FLOW_SECTION_ROWS,
  computeNetFlows = _require2.computeNetFlows,
  formatNetFlowTone = _require2.formatNetFlowTone;
var _require3 = require('./explorer-format'),
  EXPLORER_INTEGER_ONLY_KEYS = _require3.EXPLORER_INTEGER_ONLY_KEYS,
  formatExplorerInteger = _require3.formatExplorerInteger,
  formatNolanAsExplorerCurrency = _require3.formatNolanAsExplorerCurrency;
var UTXO_UNKNOWN_DISPLAY = '?';
function formatSupplyCell(value) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (options.displayUnknown || key === 'utxo') {
    return UTXO_UNKNOWN_DISPLAY;
  }
  if (EXPLORER_INTEGER_ONLY_KEYS.has(key)) {
    return formatExplorerInteger(value);
  }
  return formatNolanAsExplorerCurrency(value, {
    abbreviate: options.exactInteger !== true
  });
}
function formatNetFlowCell(nolanValue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isTotal = Boolean(options.isTotal);
  var tone = formatNetFlowTone(nolanValue, {
    isTotal: isTotal
  });
  if (nolanValue === null || nolanValue === undefined) {
    return {
      text: '—',
      tone: tone
    };
  }
  if (nolanValue === 0n) {
    return {
      text: '0',
      tone: tone
    };
  }
  var sign = nolanValue > 0n ? '+' : '−';
  var magnitude = nolanValue < 0n ? -nolanValue : nolanValue;
  return {
    text: "".concat(sign).concat(formatNolanAsExplorerCurrency(magnitude)),
    tone: tone
  };
}
function accountingRowClassName(row) {
  var classes = ['explorer-supply-row', "explorer-supply-row-".concat(row.key)];
  if (row.section === 'supply') {
    classes.push('explorer-supply-highlight');
  }
  if (row.section === 'supply-total') {
    classes.push('explorer-supply-invariant-row', 'explorer-supply-total-row');
  }
  if (row.section === 'payout') {
    classes.push('explorer-payout-highlight');
  }
  return classes.join(' ');
}
function netFlowRowClassName(fieldKey) {
  var isTotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var classes = ['explorer-supply-row', 'explorer-supply-net-flow-row', "explorer-supply-net-flow-row-".concat(fieldKey)];
  if (isTotal) {
    classes.push('explorer-supply-net-flow-total-row');
  }
  return classes.join(' ');
}
function buildAccountingRow(row, statsRows) {
  var accountingRow = {
    key: row.key,
    label: row.label,
    className: accountingRowClassName(row),
    isNetFlow: false,
    values: statsRows.map(function (column) {
      return formatSupplyCell(column === null || column === void 0 ? void 0 : column[row.key], row.key, {
        displayUnknown: row.displayUnknown
      });
    })
  };
  if (row.section === 'supply-total') {
    accountingRow.exactValues = statsRows.map(function (column) {
      return formatSupplyCell(column === null || column === void 0 ? void 0 : column[row.key], row.key, {
        exactInteger: true
      });
    });
  }
  return accountingRow;
}
function buildSectionDivider(key) {
  return {
    key: key,
    isSectionDivider: true
  };
}
function buildSectionTitle(label) {
  return {
    key: 'net_flow_section_title',
    isSectionTitle: true,
    label: label
  };
}
function buildNetFlowSectionRows() {
  var blockFlows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rows = [buildSectionDivider('net_flow_section_start'), buildSectionTitle(NET_FLOW_SECTION_TITLE)];
  var _loop = function _loop() {
    var field = NET_FLOW_SECTION_ROWS[i];
    var isTotal = field.key === 'total';
    rows.push({
      key: "net_flow_".concat(field.key),
      label: field.label,
      className: netFlowRowClassName(field.key, isTotal),
      isNetFlow: true,
      isTotal: isTotal,
      section: 'net-flow',
      values: blockFlows.map(function (entry) {
        var _entry$flows;
        return formatNetFlowCell((_entry$flows = entry.flows) === null || _entry$flows === void 0 ? void 0 : _entry$flows[field.key], {
          isTotal: isTotal
        });
      })
    });
  };
  for (var i = 0; i < NET_FLOW_SECTION_ROWS.length; i++) {
    _loop();
  }
  rows.push(buildSectionDivider('net_flow_section_end'));
  return rows;
}
function buildValueRows(tableRows, statsRows) {
  return tableRows.map(function (row) {
    return buildAccountingRow(row, statsRows);
  });
}

/**
 * Assemble the full supply table: reserve buckets, net-flow section, then trailing rows.
 */
function formatSupplyTable() {
  return _formatSupplyTable.apply(this, arguments);
}
function _formatSupplyTable() {
  _formatSupplyTable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var statsRows,
      options,
      blockFlows,
      _splitSupplyTableRows,
      reserveRows,
      trailingRows,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          statsRows = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          _context.n = 1;
          return computeNetFlows(statsRows, options);
        case 1:
          blockFlows = _context.v;
          _splitSupplyTableRows = splitSupplyTableRows(), reserveRows = _splitSupplyTableRows.reserveRows, trailingRows = _splitSupplyTableRows.trailingRows;
          return _context.a(2, [].concat(_toConsumableArray(buildValueRows(reserveRows, statsRows)), _toConsumableArray(buildNetFlowSectionRows(blockFlows)), _toConsumableArray(buildValueRows(trailingRows, statsRows))));
      }
    }, _callee);
  }));
  return _formatSupplyTable.apply(this, arguments);
}
module.exports = {
  UTXO_UNKNOWN_DISPLAY: UTXO_UNKNOWN_DISPLAY,
  formatSupplyCell: formatSupplyCell,
  formatSupplyTable: formatSupplyTable,
  formatNetFlowCell: formatNetFlowCell,
  buildNetFlowSectionRows: buildNetFlowSectionRows
};